import { useEffect, useMemo, createContext, useContext } from "react";

import { TimeFrameType } from "src/organization/pages/project/environment/metrics/resources/types";
import PollerPool from "src/organization/pages/project/environment/metrics/utils/polling/pollerpool";

type Props = {
  timeframe: TimeFrameType;
  interval?: number;
};

const usePollgroup = ({ timeframe, interval = 30 }: Props) => {
  const pollgroup = useMemo(() => new PollerPool(), []);

  useEffect(() => {
    timeframe.id
      ? pollgroup.startPolling(interval, timeframe)
      : pollgroup.pollOnce(timeframe);
  }, [interval, pollgroup, timeframe]);

  useEffect(() => {
    return () => pollgroup.stopPolling();
  }, [pollgroup]);

  return { pollgroup };
};

type PollgroupContextType = {
  pollgroup: PollerPool;
};

export const PollgroupContext = createContext<PollgroupContextType>(
  undefined as any
);

export const usePollgroupContext = () => {
  return useContext(PollgroupContext);
};

export default usePollgroup;
